import { Services } from '@sigma-frontend-libs/commons'

import { components } from '@/utils'

import tag from '@/components/tag'

export default function(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy,
        label: this.label || this.getTranslate(`${Services.sendings}.filter.state.status`),
        items: this.items,
        labelMode: this.labelMode,
        dense: this.dense,
        required: this.required,
        clearable: this.clearable,
        details: this.details
      },
      scopedSlots: {
        selection: ({ item }) => {
          let as = 'select'
          if (this.dense) {
            as = 'select-dense'
          }

          return h(
            tag,
            {
              props: {
                label: item.title,
                color: item._item.color,
                as
              }
            }
          )
        }
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}
